import React, { useEffect, useState } from 'react';
import BackToTop from '../../components/elements/BackToTop';
import Header from '../../components/Layout/Header';
import navImg1 from '../../assets/images/resources/logo-1.png';
import FooterTwo from '../../components/Layout/Footer/FooterStyleTwo';
import SiteBreadcrumb from '../../components/Common/Breadcumb';
import bannerbg from '../../assets/images/backgrounds/breadcrumb-1-1-1.webp';
import CtaTwo from '../../components/Common/CtaSection/CtaTwo';
import ReliableMain from './ReliableMain';

// Breadcrumbs Background Image

const Reliable = () => {

    const [isVisible, setIsVisible] = useState(false);

    const handleScroll = () => {
        const scrollTop = window.scrollY;
        if (scrollTop > 300) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    return (
        <React.Fragment>
        <Header
            navImg={navImg1}
            parentMenu='reliable-roof-repair'
            activeMenu="/reliable-roof-repair"
        />
        {/* SiteBreadcrumb */}
        <SiteBreadcrumb
            pageTitle="API Security"
            pageName="API Security"
            breadcrumbsImg={bannerbg}
        />
        {/* SiteBreadcrumb */}
        <ReliableMain/>
        {/*cta-section */}
        <CtaTwo/>
        {/*cta-section end */}
        <BackToTop scroll={isVisible} />
        <FooterTwo />
    </React.Fragment>
    );
}

export default Reliable;